import React, { memo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Checkbox from "../../CheckboxParams";
import "./style.css";

/**
 * @name Parameters
 * @constant
 * @function
 * @description displays the "Choose Parameters" button
 * @param {*} props
 */
const ManageParameters = (props) => {
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  useEffect(() => {
    const allChecked = props.parameters.every((param) =>
      props.selections.includes(param.id)
    );
    setSelectAllChecked(allChecked);
  }, [props.selections]);

  /**
   * @name isSelected
   * @function
   * @description Determines if the provided ID is among the selected parameters
   * @param {string} id ID of the parameter to check
   */
  function isSelected(id) {
    return props.selections.includes(id);
  }

  /**
   * @name handleSelectAll
   * @function
   * @description Handles the selection of all parameters under the classification
   */
  function handleSelectAll() {
    setSelectAllChecked(!selectAllChecked);
    if (!selectAllChecked) {
      const selectedParameterIds = props.parameters.map((param) => param.id);
      const newSelections = selectedParameterIds.filter(
        (paramId) => !props.selections.includes(paramId)
      );
      props.updateSelections([...props.selections, ...newSelections]);
    } else {
      const deselectedParameterIds = props.parameters.map((param) => param.id);
      props.updateSelections(
        props.selections.filter((id) => !deselectedParameterIds.includes(id))
      );
    }
  }

  if (props.parameters.length === 0) return null;

  return (
    <ul className="classification__column" aria-label={props.classification}>
      <div className="classification-title">
        <Checkbox
          label={props.classification}
          title={props.classification}
          isClassificationTitle
          onClick={handleSelectAll}
          checked={selectAllChecked}
          parameters={props.parameters}
          selections={props.selections}
          showAllChecked={props.showAllChecked}
          setShowAllChecked={props.setShowAllChecked}
          selectionsLength={props.selectionsLength}
          allParamsLength={props.allParamsLength}
          tabIndex={0}
        />
      </div>
      {props.parameters.map((parameter, index) => {
        let name = parameter.name;
        if (parameter.delay) name += ` (${parameter.delay})`;
        return (
          <Checkbox
            onClick={props.onClick}
            id={"parameter-" + parameter.id}
            key={"parameter-" + index}
            label={name}
            title={name}
            checked={isSelected(parameter.id)}
            value={parameter.id}
            selections={props.selections}
            parameters={props.parameters}
            showAllChecked={props.showAllChecked}
            setShowAllChecked={props.setShowAllChecked}
            selectionsLength={props.selectionsLength}
            allParamsLength={props.allParamsLength}
          />
        );
      })}
    </ul>
  );
};

ManageParameters.defaultProps = {
  parameters: [],
  selections: [],
};

ManageParameters.propTypes = {
  classification: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      delay: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  selections: PropTypes.arrayOf(PropTypes.string),
  updateSelections: PropTypes.func.isRequired,
  showAllChecked: PropTypes.bool,
  setShowAllChecked: PropTypes.func,
  selectionsLength: PropTypes.number,
  allParamsLength: PropTypes.number,
};

export default memo(ManageParameters);
